import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import Select from 'react-select';
import CircularProgress from '@mui/material/CircularProgress';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const CustomerEdit = ({ match }) => {
  const history = useHistory();
  const recordId = match.params.id;
  const { id } = useParams();
  const { isAuthenticated, companyId, userId, token, logout } = useAuth();

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) {
      logout();
      return;
    }
  }, [isAuthenticated, token, logout]);

  const [formData, setFormData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [roomName, setRoomName] = useState([]);
  const [roomTypeOptions, setRoomTypeOptions] = useState([]);
  const [selectedRoomType, setSelectedRoomType] = useState(null); // Initialize as null
  const [customRentAmount, setCustomRentAmount] = useState('');
  const [selectedIDCard, setSelectedIDCard] = useState("");
  const [cardTypeOptions, setcardTypeOptions] = useState([]);
  const [selectedCardType, setSelectedCardType] = useState(null); // Initialize as null

  useEffect(() => {
    fetchData('CustomerApi', `/CustomerEdit/${id}`, token)
      .then((response) => {
        if (response.responseCode === '1111') {
          setFormData(response.response_data);
        }
      })
      .catch((error) => {
        console.error('Error fetching Customer Details:', error);
      });
  }, [id]);

  useEffect(() => {
    const fetchRoomTypes = async () => {
      try {
        const response = await fetchData('CustomerApi', `/RommDetails/${companyId}`);
        if (response.responseCode === '1111') {
          const options = response.response_data.map(room => ({
            value: room.ID,
            label: room.Name
          }));
          setRoomName(response.response_data);
          setRoomTypeOptions(options);

          const defaultRoom = options.find(option => option.value === formData.roomName);
          if (defaultRoom) {
            setSelectedRoomType(defaultRoom);
            const selectedRoomData = response.response_data.find(room => room.ID === defaultRoom.value);
            if (selectedRoomData) {
              setCustomRentAmount(selectedRoomData.RentAmount || formData.rentAmount);
            }
          }
        }
      } catch (error) {
        console.error('Error fetching Room Types:', error);
      }
    };

    fetchRoomTypes();
  }, [companyId, formData.roomName, fetchData]);

  const handleRoomChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedRoomType(selectedOption);
      const selectedRoomData = roomName.find(room => room.ID === selectedOption.value);
      if (selectedRoomData) {
        setCustomRentAmount(selectedRoomData.RentAmount || '');
      }
    } else {
      setCustomRentAmount(formData.rentAmount || '');
    }
  };

  const handleChanges = (event) => {
    const { name, value } = event.target;
    const newValue = value.trim() === '' ? 0 : Number(value);
    if (name === 'customRentAmount') {
      setCustomRentAmount(newValue);
    }
  };

  const fetchCardTypes = async () => {
    try {
      const response = await fetchData('CustomerApi', `/${companyId}/${companyId}`, token);
      const options = response.map(Card => ({
        value: Card.id,
        label: Card.cardName
      }));
      setcardTypeOptions(options);
    } catch (error) {
      console.error('Error fetching Customer Types:', error);
    }
  };

  const handleCardTypeChange = (selectedOption) => {
    setSelectedCardType(selectedOption);
  };

  useEffect(() => {
    fetchCardTypes();
  }, [companyId, token]);

  const formatDateForInput = (dateString) => {
    const currentDate = new Date(dateString);
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
  
    const updatedFormData = {
      ...formData,
      RoomId: selectedRoomType?.value, // Ensure RoomId is a number
      IdCardId: selectedCardType?.value,  // Ensure IdCardId is a number
      RoomRentCustomer: customRentAmount || 0,
      UpdatedBy: userId,
    };
  
    try {
      await updateData('CustomerApi', `${id}`, updatedFormData, token);
      history.push('/CustomerIndex');
    } catch (error) {
      console.error('Error updating record:', error);
      setIsLoading(false);
    }
  };
  

  return (

    <div className="w-full max-w-sm container mt-6 mx-auto">
      <form onSubmit={handleSubmit}>
        <div className='w-full mb-2 flex items-center'>
          <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>CUSTOMER EDIT</h6>

          <Tooltip title="Exit">
            <Link to="/CustomerIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
              <Button style={{ color: 'brown', fontWeight: 'bolder' }}>
                Back To List <ArrowForwardIosIcon />
              </Button>
            </Link>
          </Tooltip>


          <Tooltip title="Update">

            <Button onClick={handleSubmit} style={{ color: 'green', fontWeight: 'bolder' }} disabled={isLoading}>
              {isLoading ? <CircularProgress size={24} color="inherit" /> : "Update"} <CheckCircleIcon />
            </Button>

          </Tooltip>

        </div>


        <div className="w-full mb-4 flex">

          <div className="w-1/2 mr-2">
            <label className="block  tracking-wide text-black text-base  mb-2" htmlFor="Name">
              Name
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="name"
              value={formData.name}
              onChange={handleChange}
              type="text"
              placeholder="Enter Name"
            />
          </div>

          <div className="w-1/4 mr-2">
            <label className="block tracking-wide text-black text-base mb-2" htmlFor="contactNumber1">
              ContactNo:1
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="contactNumber1"
              value={formData.contactNumber1}
              onChange={handleChange}
              type="text"
              placeholder="Contact Number 1"
            />
          </div>

          <div className="w-1/4 mr-2">
            <label className="block tracking-wide text-black text-base mb-2" htmlFor="contactNumber2">
              ContactNo:2
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="contactNumber2"
              value={formData.contactNumber2}
              onChange={handleChange}
              type="text"
              placeholder="Contact Number 2"
            />
          </div>

          <div className="w-1/3 mr-2">
            <label className="block  tracking-wide text-black text-base  mb-2" htmlFor="email">
              Email
            </label>
            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="email"
              value={formData.email}
              onChange={handleChange}
              type="text"
              placeholder="Email" />
          </div>


        </div>

        <div className="w-full mb-4 flex">

          <div className="w-1/2 mr-2">
            <label className="block  tracking-wide text-black text-base  mb-2" htmlFor="AddressLine1">
              Address Line 1
            </label>
            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="addressLine1"
              value={formData.addressLine1}
              onChange={handleChange}
              type="text"
              placeholder="Address Line 1" />
          </div>

          <div className="w-1/2 mr-2">
            <label className="block  tracking-wide text-black text-base  mb-2" htmlFor="AddressLine2">
              Address Line 2
            </label>
            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="adressLine2"
              value={formData.adressLine2}
              onChange={handleChange}
              type="text"
              placeholder="Address Line 2" />
          </div>
          <div className="w-1/3 mr-2">
            <label className="block  tracking-wide text-black text-base  mb-2" htmlFor="Location">
              Location
            </label>
            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="location"
              value={formData.location}
              onChange={handleChange}
              type="text"
              placeholder="Location" />
          </div>

        </div>
        <div className="w-full mb-4 flex">
          <div className="w-1/3 mr-2">
            <label className="block tracking-wide text-black text-xs  mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
              ID PROOF
            </label>
            <Select
              value={selectedCardType || (formData.cardType ? { value: formData.cardType, label: formData.cardType } : '')}
              onChange={handleCardTypeChange}
              options={cardTypeOptions}
              placeholder="ID PROOF"
              isSearchable
            />

          </div>
          <div className="w-1/3 mr-2">
            <label className="block  tracking-wide text-black text-base  mb-2" htmlFor="ProofNo">
              ProofNo
            </label>
            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="proofNo"
              value={formData.proofNo}
              onChange={handleChange}
              type="text"
              placeholder="ProofNo" />
          </div>
         
          <div className="w-1/3 mr-2">
            <label className="block tracking-wide text-black text-xs mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
              Room
            </label>
            <Select
              value={selectedRoomType || (formData.roomName ? { value: formData.roomName, label: formData.roomName } : '')}
              onChange={handleRoomChange}
              options={roomTypeOptions}
              placeholder="Select Room"
              isSearchable
            />
          </div>

          {!selectedRoomType && (
            <div className="w-1/3 mr-2">
              <label className="block tracking-wide text-black text-base mb-2" htmlFor="customRentAmount">
                Customer Rent Amount
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                name="rentAmount"
                value={formData.rentAmount || ''}
                onChange={handleChange}
                type="text"
                style={{ backgroundColor: 'white' }}
                placeholder="Enter Rent Amount"
              />
            </div>
          )}

          {selectedRoomType && (
            <div className="w-1/3 mr-2">
              <label className="block tracking-wide text-black text-base mb-2" htmlFor="roomName">
                Customer Room Name
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                value={(formData.roomName || '') + '-' + ' ₹' + (formData.rentAmount || '')}
                onChange={handleChange}
                type="text"
                style={{ backgroundColor: 'white' }}
                placeholder="Enter Room Name"
                disabled
              />
            </div>
          )}


          {selectedRoomType && (
            <div className="w-1/3 mr-2">
              <label className="block tracking-wide text-black text-base mb-2" htmlFor="customRentAmount">
                Room Rent Amount
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                name="customRentAmount"
                value={customRentAmount || ''}
                onChange={handleChanges}
                type="text"
                style={{ backgroundColor: 'white' }}
                placeholder="Enter Rent Amount"
              />
            </div>
          )}


          <div className="w-1/3 mr-2">
            <label className="block  tracking-wide text-black text-base  mb-2" htmlFor="RentDate">
              RentDate
            </label>
            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="rentDate"
              value={formatDateForInput(formData.rentDate)}
              onChange={handleChange}
              type="date"
              placeholder="RentDate" />
          </div>
        </div>
        <div className="w-full mb-4 flex">
          <div className="w-1/3 mr-2">
            <label className="block tracking-wide text-black text-base mb-2" htmlFor="DateOfJoining">
              DateOfJoining
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="dateOfJoining"
              value={formatDateForInput(formData.dateOfJoining)}
              onChange={handleChange}
              type="date"
              placeholder="DateOfJoining"
            />
          </div>

          <div className="w-1/3 mr-2">
            <label className="block tracking-wide text-black text-base mb-2" htmlFor="DateOfLeaving">
              DateOfLeaving
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="dateOfLeaving"
              value={formatDateForInput(formData.dateOfLeaving)}
              onChange={handleChange}
              type="date"
              placeholder="DateOfLeaving"
            />
          </div>


          <div className="w-1/3 mr-2">
            <label className="block  tracking-wide text-black text-base  mb-2" htmlFor="CautionDeposite">
              CautionDeposit
            </label>
            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              value={formData.cautionDeposite}
              onChange={handleChange}
              type="text"
              placeholder="CautionDeposite" />
          </div>
          <div className="w-4/5 mr-2">
            <label className="block  tracking-wide text-black text-base  mb-2" htmlFor="CustomerRemark">
              Customer Remark
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              value={formData.customerRemark}
              onChange={handleChange}
              type="text"
              placeholder="Enter Customer Remark"

            />
          </div>
        </div>

      </form >

    </div >

  );
};

export default CustomerEdit;
